import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { SubmissionTable } from "./table";
import { Card, useLanguageTranslator } from "../../../../../components";

function AdminView({
  pendingData = [],
  noPendingData = [],
  title = "",
  viewPath,
  viewAllSubmissionsPath,
  onAdminActions,
  isAdminPeople= false,
}: any) {
  const { translator } = useLanguageTranslator();
  return (
    <>
      <Container sx={{ my: 3 }}>
        <Paper component={Container} sx={{ py: 3 }}>
          <Stack
            direction={{ lg: "row" }}
            gap={2}
            justifyContent={{ lg: "space-between" }}
            alignItems={{ lg: "center" }}
          >
            <Box>
              <Typography variant="h4">
                {translator("Students Submissions")}
              </Typography>
            </Box>
            <Box>
              <Button
                component={RouterLink}
                to="new"
                sx={{
                  px: 6,
                  backgroundColor: "#F6A000",
                  color: "#ffffff",
                  "&:hover": {
                    backgroundColor: "primary.light",
                  },
                }}
              >
                {translator("generic.CREATE")}
              </Button>
            </Box>
          </Stack>
        </Paper>
        <SubmissionTable
          viewAllPath={viewAllSubmissionsPath}
          data={pendingData}
          viewPath={viewPath}
          isAdminPeople={isAdminPeople}
        />
      </Container>
      <Container sx={{ my: 3 }}>
        <Paper component={Container} sx={{ py: 2, mb: 2 }}>
          <Stack
            direction={{ lg: "row" }}
            justifyContent={{ lg: "space-between" }}
            alignItems={{ lg: "center" }}
          >
            <Typography variant="h4">
              {translator("status.Approved")} & {translator("status.Rejected")}{" "}
              {title}
            </Typography>
            <Link
              component={RouterLink}
              to="all"
              underline="none"
              color="textSecondary"
            >
              {translator("View all")}
            </Link>
          </Stack>
        </Paper>
        <Grid container spacing={2}>
          {noPendingData?.map((p: any, i: any) => (
            <Grid key={`${i}`} item xs={12} md={6} lg={3}>
              <Slide in timeout={180 * (i + 1)} direction="right">
                <Card
                  {...p}
                  path={`${viewPath}${p?.id}`}
                  sx={{ height: "100%" }}
                  isAdmin={true}
                  onAdminActions={onAdminActions}
                  isAdminPeople={isAdminPeople}
                />
              </Slide>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
}

export { AdminView };
